export default {
    first:  'first',
    second: 'second',
};
